const TENANT_STORAGE_KEY = 'rocqtr_tenant_identifier';

export const getStoredTenantIdentifier = (): string | null => {
  try {
    return localStorage.getItem(TENANT_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setStoredTenantIdentifier = (tenantIdentifier: string): void => {
  try {
    localStorage.setItem(TENANT_STORAGE_KEY, tenantIdentifier);
  } catch {
    // Ignore localStorage errors
  }
};

export const clearStoredTenantIdentifier = (): void => {
  try {
    localStorage.removeItem(TENANT_STORAGE_KEY);
  } catch {
    // Ignore localStorage errors
  }
};